import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SecurityUserLoginModel } from 'src/app/model/security/security-user.login';
import { adminUserActions } from 'src/app/store/admin/user/admin-user.action';
import { environment } from 'src/environments/environment';
import { BaseService } from '../../base/base.service';
import { RestService } from '../../service/rest.service';

@Injectable({
  providedIn: 'root',
})
export class KhuyanaHeaderService extends BaseService {
  constructor(override store: Store<any>, protected rest: RestService) {
    super();
  }

  getTurnsQuantity = (): Observable<number> =>
    this.store.select('common', 'turn', 'totalTurns');

  readUser = (): Observable<any> =>
    this.rest
      .get<SecurityUserLoginModel>({
        url: `${environment.endpoints.auth}/who-am-i`,
      })
      .pipe(
        tap((user) =>
          this.store.dispatch(adminUserActions.setResultAction(user))
        )
      );
}
